<template>
  <div>
    <div class="card" @click="goToProfile($event)">
      <div class="d-flex">
        <div class="child-1">
          <img
            class="profile-pic"
            v-if="profile_object.profile_image"
            :src="profile_object.profile_image"
            alt=""
          />
          <v-avatar
            class="profile-pic"
            style="background-color: lightblue"
            size="60"
            v-if="!profile_object.profile_image"
          >
            <span
              class="initials"
              style="color: #111; font-weight: 700; font-size: 30px"
              >{{ profile_object.name | reduceToInitials }}</span
            >
          </v-avatar>
        </div>

        <div class="child-2">
          <h3 class="user__name">
            {{ this.profile_object.name }}
            <img
              @mouseover="tooltip = true"
              @mouseout="tooltip = false"
              id="sebi-badge"
              v-if="profile_object.is_sebi_registered"
              :src="sebi_badge"
              alt=""
              style="margin-bottom: -5px"
            />
            <p id="sebi-tooltip" v-if="tooltip">SEBI Registered</p>
          </h3>

          <div class="figures__container" style="">
            <div class="grand-child-1">
              <div>
                <p>
                  <v-icon style="margin: 0 3px 3px 0px; color: black" size="18"
                    >mdi-account-outline</v-icon
                  >
                  <span class="figure">{{
                    this.profile_object.followers
                  }}</span>
                  Followers
                </p>
              </div>
              <div>
                <v-btn
                  class="follow-btn"
                  height="40"
                  color="#2d8cff"
                  outlined
                  v-if="isFollower"
                  @click="unFollowUser(profile_object.user_id)"
                  >Unfollow</v-btn
                >
                <v-btn
                  v-if="!isFollower"
                  color="#2d8cff"
                  height="46"
                  class="follow-btn"
                  @click="followUser(profile_object.user_id)"
                >
                  Follow
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex second-div">
        <div class="posted">
          <p class="pt-3 px-2">
            <v-icon style="margin: 0 3px 3px 0px; color: black" size="18"
              >mdi-text-box-outline</v-icon
            >
            <span class="figure">{{ profile_object.trades_count }} </span>
            Trades
            <!-- percentBool? '#27AE60': '#eb5757'  -->
            <span v-if="percent != 0">
              <!-- <v-icon size="15" class="mb-1"  :color="percentBool? '#27AE60': '#eb5757'">mdi-bullseye-arrow</v-icon> -->
              <v-img :src="target" class="target-img"></v-img>

              <span
                style="font-size: 11px; padding-left: 2px"
                :class="percentBool ? 'figure-percent' : 'figure-neg-percent'"
                >{{ percent }} %
              </span>
            </span>
          </p>
        </div>
        <div class="instrument-types">
          <p class="pt-3 px-2">
            <v-icon style="margin: 0 3px 1px 0px; color: black" size="18"
              >mdi-sack</v-icon
            >
            <span
              style="text-overflow: ellipsis !important"
              :class="
                profile_object.days_pnl >= 0
                  ? 'figure-percent'
                  : 'figure-neg-percent'
              "
            >
              {{ profile_object.days_pnl }}({{
                profile_object.days_pnl_percent
              }}%)
            </span>
            <span>Daily P&L</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
// import { getImgLink } from "../../common/commonFunctions.js";
import Axios from "@/api/BaseAxios.js";
import { isAuthenticated } from "../../common/commonFunctions.js";

export default {
  name: "ProfileCardComponent",
  props: ["profile_object"],
  data: () => ({
    is_user_follow: false,
    sebi_badge: require("@/assets/images/gold_check.svg"),
    target: require("@/assets/images/target_1.png"),
    tooltip: false,
  }),

  computed: {
    computedTypeOfInstrument() {
      if (this.profile_object) {
        const typeOfInstruments =
          this.profile_object.types_of_instrument.join(", ");

        let shrinkedText = "";
        if (typeOfInstruments.length > 25)
          shrinkedText = typeOfInstruments.substring(0, 20) + "...";
        else shrinkedText = typeOfInstruments;

        return shrinkedText;
      }
      return "";
    },
    isFollower() {
      return this.profile_object.is_followed ? true : false;
      // const user_id = localStorage.getItem("user_id");
      // const followers = this.profile_object.followers_ids.filter((item) => {
      //   return Number(item) == Number(user_id);
      // });
      // if (followers.length) {
      //   return true;
      // }
      // return false;
    },
    percent() {
      return Math.abs(this.profile_object.percent).toFixed(2);
    },
    percentBool() {
      return this.profile_object.percent >= 0;
    },
    percentIcon() {
      if (this.percentBool) {
        return "mdi-arrow-up";
      } else {
        return "mdi-arrow-down";
      }
    },
  },

  methods: {
    ...mapActions("snackBar", ["showSnack"]),
    // getImg(link) {
    //   return getImgLink(link);
    // },
    viewProfile(id) {
      this.$router.push({ name: "OthersProfilePage", params: { id: id } });
    },
    shareProfile(id, name) {
      navigator
        .share({
          title: "Covesto",
          text: `Follow ${name} on Covesto to transition from individual investing to community covesting`,
          url: `https://covesto.in/profile/${id}/${name}`,
        })
        .then(() => console.log("Yay, you shared it :)"))
        .catch((error) => {
          console.log(error);
        });
    },
    goToProfile(e) {
      if (
        e.target.className === "user__name" ||
        e.target.className === "v-avatar" ||
        e.target.className === "initials" ||
        e.target.className === "profile-pic"
      ) {
        this.$router.push({
          name: "OthersProfilePage",
          params: {
            id: this.profile_object.user_id,
            name: this.profile_object.name,
          },
        });
      }
    },
    unFollowUser(to_unfollow_id) {
      const user_id = localStorage.getItem("user_id");
      const successHandler = (res) => {
        this.profile_object.is_followed = false;
        // this.getProfileDetails();
        this.showSnack({
          text: `${res.data.message}`,
          color: "success",
          timeout: 4500,
        });
        this.$emit("unfollow", { user_id, to_unfollow_id });
        this.$logEvent("unfollowed_profile");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_unfollowed_profile");
        }
      };
      const data = {
        user_id: user_id,
        to_unfollow_id: to_unfollow_id,
      };
      const errorHandler = (err) => {
        this.showSnack({
          text: `${err.data.message}`,
          color: "success",
          timeout: 4500,
        });
      };
      Axios.request_POST(
        "/api/un-follow-influencer/",
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },

    followUser(to_follow_id) {
      if (!isAuthenticated()) {
        this.showSnack({
          text: "Login to follow another User",
          color: "success",
          timeout: 4500,
        });
        return;
      }
      const user_id = localStorage.getItem("user_id");
      const successHandler = (res) => {
        this.profile_object.is_followed = true;

        // this.getProfileDetails();
        this.showSnack({
          text: `${res.data.message}`,
          color: "success",
          timeout: 4500,
        });
        this.$emit("follow", { user_id, to_follow_id });
        this.$logEvent("followed_profile");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_followed_profile");
        }
      };
      const data = {
        user_id: user_id,
        to_follow_id: to_follow_id,
      };
      const errorHandler = (err) => {
        this.showSnack({
          text: `${err.data.message}`,
          color: "success",
          timeout: 4500,
        });
      };
      Axios.request_POST(
        "/api/follow-influencer/",
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  background-color: white;
  width: 100%;
  // display: flex;
  // align-items: flex-start;
  // flex-direction: row;
  box-shadow: 0px 1px 8px rgba(34, 123, 232, 0.14);
  border-radius: 8px;
  // padding: 10px 10px 0px 10px;
  min-height: 110px !important;
}
.second-div {
  margin: 0px 0px 10px 0px;
  height: 45px;
  border-top: 0.0009em solid rgb(206, 204, 204);
}
.child-1 {
  width: 20%;
  padding: 10px;
}
.child-2 {
  width: 80%;
  padding: 10px !important;
}

.posted {
  border-right: 0.0009em solid rgb(206, 204, 204);
  width: 45%;
}
.profile-pic {
  width: 100% !important;
  height: 60px !important;
  object-fit: cover;
  border-radius: 6px;
  cursor: pointer;
}
.user__name {
  cursor: pointer;
  color: #333333;
}

p {
  font-size: 12px;
  color: rgba(51, 51, 51, 0.7);
}

.figure {
  font-weight: bolder !important;
  font-size: 14px;
  color: black;
}

.buttons {
  margin-top: 10px;
}
.share-button {
  padding: 6px 8px !important;
  margin-right: 10px;
}
h3 {
  margin-bottom: 10px;
}
.figure-percent {
  color: #27ae60;
}
.figure-neg-percent {
  color: #eb5757;
}
button {
  border: 1px solid #2d8cff;
  color: #0f1011;
  box-shadow: 0px 1px 8px rgba(34, 123, 232, 0.14);
  border-radius: 8px;
  font-size: 13px;
  padding: 8px 10px;
  font-weight: 600;
}
.figures__container {
  padding: 0px 0px;
}
.grand-child-1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.target-img {
  display: inline-block;
  height: 15px;
  object-fit: cover;
  width: 15px;
}
#sebi-tooltip {
  width: 10%;
  margin-left: 50px;
  background-color: lightblue;
}
#sebi-tooltip::after {
  content: " ";
  position: absolute;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent lightblue transparent;
}
#sebi-tooltip {
  font-size: 13px;
  text-align: center;
  position: absolute;
  z-index: 1;
  padding: 5px;
  border-radius: 6px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}
.follow-btn {
  width: 100px;
  color: white;
  text-transform: capitalize;
  letter-spacing: 0px;
  height: 30px !important;
}
@media all and (max-width: 400px) {
  .child-1 {
    width: 20%;
  }

  .profile-pic {
    width: 100%;
    height: 100px;
    object-fit: cover;
    border-radius: 6px;
  }
  .child-2 {
    width: 80%;
    padding-left: 15px;
  }
  .figure {
    font-size: 11px;
  }
  h3 {
    font-size: 18px;
  }
}
@media all and (min-width: 768px) {
  .child-1 {
    width: 22%;
  }

  .child-2 {
    width: 78%;
    padding: 0px 10px;
  }

  .profile-pic {
    height: 70px !important;
    width: 70px !important;
  }

  h3 {
    font-size: 18px;
  }

  .grand-child-1,
  .grand-child-2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .share-button {
    margin-right: 10px !important;
  }

  .figure {
    font-size: 13px;
  }
}
@media all and (min-width: 1100px) {
  .profile-pic {
    height: 60px !important;
    width: 60px !important;
  }
}

@media all and (min-width: 1300px) {
  h3 {
    font-size: 18px;
  }
  .card {
    width: 100%;
  }
  .profile-pic {
    height: 70px !important;
    width: 70px !important;
  }
}
</style>
